import axios from "axios";

import {
  callApiLentra,
  REACT_APP_LENTRA_INSTITUTION_NAME,
  REACT_APP_LENTRA_CLIENT_IDENTIFIER,
  REACT_APP_LENTRA_CLIENT_SECRET,
  REACT_APP_LENTRA_LEAD_BASE_URL,
  REACT_APP_LENTRA_TOKEN_BASE_URL,
} from "../utils/lentraApiClient"; 
import { getPhoneNo, getLeadID,getCustomerID } from "../utils/storage";

// Generate Access Token API
export async function generateAccessTokenLintraAPI() {
  try {
   const req = {
  url: "api/authenticate-client",
  method: "POST",
  data: {
    sClientIdentifier: REACT_APP_LENTRA_CLIENT_IDENTIFIER,
    sClientSecret: REACT_APP_LENTRA_CLIENT_SECRET,
  },
  headers: {
    "Institution-Name": REACT_APP_LENTRA_INSTITUTION_NAME
  },
};
    const res = await callApiLentra(req, 1000);
    return res;
  } catch (error) {
    throw error;
  }
}
// Generate JWT Token API
export async function generateJWTTokenLintraAPI(mobile) {
  const tokens = localStorage.getItem("lentra_access_token");

  try {
    const res = await axios({
      url: REACT_APP_LENTRA_TOKEN_BASE_URL + "api/v3/generate_jwt",
      method: "POST",
      data: {
        sInstitutionName: REACT_APP_LENTRA_INSTITUTION_NAME,
        isInstitutionId: localStorage.getItem("lentra_institutionId"),
        mClaims: {
          authToken: tokens,
        },
      },
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${tokens}`,
      },
    });
    return res.data;
  } catch (error) {
    throw error;
  }
}

export async function createLeadIdAPI() {
  try {
    const res = await axios({
      url:
        REACT_APP_LENTRA_LEAD_BASE_URL +
        "api/leads/v1/leads/get-or-create",

      method: "POST",

      data: {
        external_id: String(getLeadID()),
        contacts: [
          {
            contact_category: localStorage.getItem("customerType") === "New Customer" ? 1 : 2,
            contact_type: 1,
            external_id: String(getCustomerID()),
            phones: [
              {
                ph_number: getPhoneNo(),
                type: 1,
              },
            ],
          },
        ],
        loan_product: "STPL",
      },

      headers: {
        accept: "application/json, text/plain, */*",
        "content-type": "application/json",
        authorization: `Bearer ${localStorage.getItem(
          "lentra_access_token"
        )}`,
        "institution-name": "RAMFIN",
        "omni-app": "true",
        role: "SelfServe",
        "tenant-id": "4531",
      },
    });

    return res.data;
  } catch (error) {
    console.log("ERROR RESPONSE =>", error?.response);
    console.log("ERROR DATA =>", error?.response?.data);
    throw error;
  }
}
